import React from 'react'
import Badge from 'react-bootstrap/Badge'
import { Link} from 'gatsby'

const ContentCategory = ({ item}) => {
    if(item.data.content_category === null || item.data.content_category.length === 0) return null
    if(item.data.content_category_has_landing_page && item.data.content_category_link != null){
      return (
        <>
        <p className="h6 font-weight-bold">Category</p>
        <Badge variant="primary" key={item.uid} className="mb-2 mr-2">
          <Link className="c" to={ item.data.content_category_link.url }>  
            {item.data.content_category}
          </Link>
        </Badge>
        <p className="mb-3">For additional items of this category, please see the {item.data.content_category} page linked above.
          </p>
        </>
      )
    }
    else {
      return (
        <>
        <p className="h6 font-weight-bold">Category</p>
        <p>{item.data.content_category}</p>
        </>
       )
    }
    
  }

export default ContentCategory;